unable to read source [project]/packages/core/src/__styles.ts